<template>
    <section class="home">
		<div class="wrapper as">
		  <div class="mod-logo">
		    <a class="logo" href="start.html">
		      <img src="../../static/images/logo.png" style="width: 120px" />
		    </a>
		  </div>
		  <nav :class="['mod-navigation',pageBoolean.showMenu ? 'open' : '']">
		  <div class="nav-icon" @click.stop="toggleMenuList">
		    <span></span>
		    <span></span>
		    <span></span>
		  </div>
		  <div :class="['lang-switch',pageBoolean.showLang ? 'open' : '']">
		    <span @click.stop="toggleLangList">ZH-CN</span>
		    <div>
		      <div class="arrow">
		      </div>
		      <ul>
		        <li><a href="/de-DE/start.html"><span>GER</span></a></li>
		        <li><a href="/en-DE/start.html"><span>ENG</span></a></li>
		        <li><a href="/es-ES/start.html"><span>ESP</span></a></li>
		        <li><a href="/nl-NL/start.html"><span>NLD</span></a></li>
		        <li><a href="/fi-FI/start.html"><span>FIN</span></a></li>
		        <li><a href="/zh-TW/start.html"><span>ZH-TW</span></a></li>
		        <li><a href="/zh-CN/start.html"><span>ZH-CN</span></a></li>
		        <li><a href="/ko-KR/start.html"><span>KOR</span></a></li>
		        <li><a href="/pt-BR/start.html"><span>BRA</span></a></li>
		        <li><a href="/cs-CZ/start.html"><span>CZE</span></a></li>
		        <li><a href="/ja-JP/start.html"><span>JPN</span></a></li>
		        <li><a href="/fr-FR/start.html"><span>FRA</span></a></li>
		        <li><a href="/it-IT/start.html"><span>ITA</span></a></li>
		        <li><a href="/se-SE/start.html"><span>SWE</span></a></li>
		      </ul>
		    </div>
		  </div>
		  <ul class="menuList">
		    <li v-for="(item,index) in meanList">
		      <a href="javascript:void(0)" @click="navigatorTo(index)" :class="[item.select ? 'active' : '',,item.clicked ? 'active' : '']">
		        <span>{{ item.text }}</span>
		      </a>
		    </li>
		  </ul>
		  <ul class="metaList">
		    <li><a href="https://www.vmartaw.com/zcc/" target="_blank"><span>博主的黑科技(已开放)</span></a></li>
		    <li><router-link to="tool"><span>黑工具导航(已开放)</span></router-link></li>
		    <li><a href="#metadata"><span>音乐的聆听者</span></a></li>
		    <li><a href="#metadata"><span>海贼王的男人</span></a></li>
		    <li><a href="#metadata"><span>回忆的沙漏</span></a></li>
		    <li><a href="#metadata"><span>环游的甜蜜时光</span></a></li>
		    <li><a href="#metadata"><span>儿时的梦想</span></a></li>
		    <li><a href="#metadata"><span>永不止步</span></a></li>
		    <li><a href="#metadata"><span>探味人生</span></a></li>
		  </ul>
		  <div class="pagecontrol">
		    <div class="tool-tip-wrapper">
		      <span :class="['tool-tip',item.select ? 'active' : '']" v-for="(item,index) in meanList">{{ item.text }}</span>
		    </div>
		    <ol class="pager">
		      <li  v-for="(item,index) in meanList" @mouseover="mouseOverForSmall(index)" @mouseout="mouseOutForSmall(index)" @click="navigatorTo(index)">
		        <a :class="[item.select ? 'active' : '',item.clicked ? 'active' : '']">
		          <span>{{ item.text }}</span>
		        </a>
		      </li>
		    </ol>
		  </div>
		  <!-- <a class="partner" href="#" target="_blank"></a -->></nav>
		  <div id="pt-main" class="pt-perspective">
		    <div class="content main page-start">
		       <home :page-boolean="pageBoolean" :mean-list="meanList"></home>
		       <intro :page-boolean="pageBoolean" :mean-list="meanList"></intro>
           <advantage :page-boolean="pageBoolean" :mean-list="meanList"></advantage>
           <contact :page-boolean="pageBoolean" :mean-list="meanList"></contact>
		    </div>
		  </div>
		</div>
		<div :class="['mod-overlay-loading',pageBoolean.showLoad ? 'startload': '']">
		  <div class="arc-rotate2"><div class="loader"><div class="arc"></div></div></div>
		</div>
	</section>
</template>

<script>
import Home from 'components/page/Home'
import Intro from 'components/page/Intro'
import Advantage from 'components/page/Advantage'
import Contact from 'components/page/Contact'


export default {
 data(){
    return{
      meanList:[{
        text:'主页',
        select:true,//hover
        clicked:true,//click
        enter:false,
        leave:false
      },{
        text:'介绍及初印象',
        select:false,
        clicked:false,
        enter:false,
        leave:false
      },{
        text:'优势及特长',
        select:false,
        clicked:false,
        enter:false,
        leave:false
      },{
        text:'联系方式',
        select:false,
        clicked:false,
        enter:false,
        leave:false
      }],
      pageBoolean:{
        showMenu:false,//菜单
        showLang:false,//国际化
        showLoad:true //加载中
      }
    }
  },
  methods:{
    toggleMenuList(){
      this.pageBoolean.showMenu=!this.pageBoolean.showMenu;
    },
    toggleLangList(){
      this.pageBoolean.showLang=!this.pageBoolean.showLang;
    },
    mouseOverForSmall(index){
      for(var i=0,len=this.meanList.length;i<len;i++){
        if(index == i){
          this.meanList[i]['select']=true;
        }else{
          this.meanList[i]['select']=false;
        }
      }
      //console.log('移进'+index);
    },
    mouseOutForSmall(index){
      this.meanList[index]['select']=false;
    },
    navigatorTo(index){
      var meanList=this.meanList,currentIndex=0;
      for(var i=0,len=meanList.length;i<len;i++){
      	if(meanList[i]['clicked']){
      		this.meanList[i]['leave']=true;
      		currentIndex=i;
      	}else{
      		this.meanList[i]['leave']=false;
      	}
      	this.meanList[i]['enter']=false;
      	this.meanList[i]['clicked']=false;
      }
      //console.log('从'+currentIndex+'到'+index);
      //index去的页面pt-page-scaleUp
      this.meanList[index]['enter']=true;
      this.meanList[index]['clicked']=true;
    }
  },
  mounted() {
    //console.log('showing');
    var self=this;
    this.$nextTick(()=>{
      document.title="吴伟的主页";
      self.meanList[0]['select']=false;
    })
  },
  components: {
    Home,
    Intro,
    Advantage,
    Contact
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?19112650